import { render, staticRenderFns } from "./TransactionDetails.vue?vue&type=template&id=60e507be&"
import script from "./TransactionDetails.vue?vue&type=script&lang=js&"
export * from "./TransactionDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ccsbetaccscom/web/live/ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60e507be')) {
      api.createRecord('60e507be', component.options)
    } else {
      api.reload('60e507be', component.options)
    }
    module.hot.accept("./TransactionDetails.vue?vue&type=template&id=60e507be&", function () {
      api.rerender('60e507be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/transactions/TransactionDetails.vue"
export default component.exports